import { alpha, darken, lighten } from '@mantine/core'

type TransformColorParameters = {
  color: string
  shift?: number
  alpha?: number
}

export const transformColor = (params: TransformColorParameters) => {
  const { color, shift = 0, alpha: alphaNumber = 1 } = params

  const schema = localStorage.getItem('mantine-color-scheme') || 'light'

  const shiftFunction = schema === 'dark' ? darken : lighten

  const transformedColor = shiftFunction(color, shift)
  return alpha ? alpha(transformedColor, alphaNumber) : transformedColor
}
